import { transformRoutes } from '@backoffice-frontend/common'

const BaseRouteBuilderAreaRoutes = {
  route: '/route-builder',
  SavedTrips: {
    route: '/saved-trips',
  },
  CreateTrip: {
    route: '/create',
  },
  CreateFromVtr: {
    route: '/create-from-vtr',
  },
  EditTrip: {
    route: '/edit/:id',
  },
  AssignTrip: {
    route: '/assign/:vin',
  },
}

export const RouteBuilderAreaRoutes = transformRoutes(
  BaseRouteBuilderAreaRoutes,
)

export { BaseRouteBuilderAreaRoutes }
